export default __webpack_public_path__ + "static/media/CustomerRealCase1-en.f82c3fac.jpg";